import React from "react";
import "../../../style/LatestUpdate.css";
import ConsultativeWorkshop from "../../../images/Demo-Background.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

const WhatWeDo = () => {
  return (
    <div className="latest_section">
      <div className="container">
        <h2>What We Do</h2>
        <div className="latest_image_wrapper">

          <div className="single_wrapper">
            <div className="image_title">
              <div className="paragraph">
                <p className="blogs">Blogs</p>
                <p className="title">Title is written here</p>
                <p className="description">Description is written here</p>
              </div>
              <div className="button_wrapper">
                <button className="button">Read More <FontAwesomeIcon
                  className="caretDown"
                  icon={faAngleRight}
                /></button>
              </div>
            </div>
            <div className="image_box">
              <a
                href="/happy-new-year"
                target={"_blank"}
              >
                <img src={ConsultativeWorkshop} alt="" />
              </a>
            </div>
          </div>

          <div className="single_wrapper">
            <div className="image_title">
              <div className="paragraph">
                <p className="blogs">Blogs</p>
                <p className="title">Title is written here</p>
                <p className="description">Description is written here</p>
              </div>
              <div className="button_wrapper">
                <button className="button">Read More <FontAwesomeIcon
                  className="caretDown"
                  icon={faAngleRight}
                /></button>
              </div>
            </div>
            <div className="image_box">
              <a
                href="/happy-new-year"
                target={"_blank"}
              >
                <img src={ConsultativeWorkshop} alt="" />
              </a>
            </div>
          </div>

          <div className="single_wrapper">
            <div className="image_title">
              <div className="paragraph">
                <p className="blogs">Blogs</p>
                <p className="title">Title is written here</p>
                <p className="description">Description is written here</p>
              </div>
              <div className="button_wrapper">
                <button className="button">Read More <FontAwesomeIcon
                  className="caretDown"
                  icon={faAngleRight}
                /></button>
              </div>
            </div>
            <div className="image_box">
              <a
                href="/happy-new-year"
                target={"_blank"}
              >
                <img src={ConsultativeWorkshop} alt="" />
              </a>
            </div>
          </div>

        </div>
        {/* <div className="border"></div> */}
      </div>
    </div>
  );
};

export default WhatWeDo;